export { default as activateTab } from './actions/activateTab';
export { default as closeTab } from './actions/closeTab';
export { default as setTabIsShown } from './actions/setTabIsShown';
export { default as getTabById } from './utils/getTabById';
export { default as addTab } from './utils/addTab';

// Register orchestrator
import './orchestrators/startProjectionOrchestrator';
import './orchestrators/transferProjectionOrchestrator';
import './orchestrators/onProjectionBlurOrchestrator';
import './orchestrators/onBeforeCloseMainWindowOrchestrator';
import './actions/addChatTabMutator';
